import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Surname from '../components/Surname';

const Home = () => {
  return (
    <Layout>
      <div className="hero-modern hero-name">
        <div className="container">
          <div className="hero-content-modern">
            <h1 className="hero-name-title">
              S. <Surname />
            </h1>
            <p className="hero-name-subtitle">Teacher, Traveler, Technologist</p>
          </div>
        </div>
      </div>

      <div className="photo-band">
        <div className="container">
          <div className="photo-band-grid">
            <img src="/myphotos/mongoliateacher.jpeg" alt="" className="about-img" />
            <img src="/myphotos/tshewang.jpg" alt="" className="about-img" />
            <img src="/myphotos/editor.jpg" alt="" className="about-img" />
          </div>
        </div>
      </div>

      <div className="about-content">
        <div className="container">
          <div className="skills-languages-row">
            <div className="skill-category">
              <h3>Technical Stack</h3>
              <div className="skill-list">
                <span className="skill-tag">LLM Integration &amp; Fine-tuning</span>
                <span className="skill-tag">Production ML Systems</span>
                <span className="skill-tag">NLP &amp; Computational Linguistics</span>
                <span className="skill-tag">AI Orchestration &amp; Workflows</span>
                <span className="skill-tag">Python, PyTorch, Transformers</span>
                <span className="skill-tag">Multilingual NLP</span>
              </div>
            </div>

            <div className="skill-category">
              <h3>Domain Expertise</h3>
              <div className="skill-list">
                <span className="skill-tag">Misinformation Research</span>
                <span className="skill-tag">Education Technology</span>
                <span className="skill-tag">Applied Linguistics</span>
                <span className="skill-tag">Political Economy</span>
                <span className="skill-tag">Cross-cultural Product Development</span>
                <span className="skill-tag">Grammar &amp; Translation Systems</span>
              </div>
            </div>

            <div className="skill-category">
              <h3>Full Stack &amp; Cloud</h3>
              <div className="skill-list">
                <span className="skill-tag">Full Stack Web Development</span>
                <span className="skill-tag">JavaScript &amp; TypeScript</span>
                <span className="skill-tag">REST, GraphQL &amp; gRPC APIs</span>
                <span className="skill-tag">Cross-platform Mobile Apps</span>
                <span className="skill-tag">Scalable Deployment on AWS</span>
                <span className="skill-tag">Containers &amp; CI/CD Pipelines</span>
              </div>
            </div>

            <div className="skill-category">
              <h3>What Sets Me Apart</h3>
              <div className="skill-list">
                <span className="skill-tag">Field research in remote contexts</span>
                <span className="skill-tag">Distributed team collaboration</span>
                <span className="skill-tag">Technical-to-non-technical translation</span>
                <span className="skill-tag">Shipping AI products, not demos</span>
              </div>
            </div>

            <div className="languages-section">
              <h2>Languages</h2>
              <div className="language-bars">
                <div className="language-item">
                  <span className="language-name">English</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-native"
                      style={{ width: '100%' }}
                    ></div>
                  </div>
                </div>

                <div className="language-item">
                  <span className="language-name">Français</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-professional"
                      style={{ width: '90%' }}
                    ></div>
                  </div>
                </div>

                <div className="language-item">
                  <span className="language-name">Español</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-professional"
                      style={{ width: '90%' }}
                    ></div>
                  </div>
                </div>

                <div className="language-item">
                  <span className="language-name">Português</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-conversational"
                      style={{ width: '70%' }}
                    ></div>
                  </div>
                </div>

                <div className="language-item">
                  <span className="language-name">日本語</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-conversational"
                      style={{ width: '65%' }}
                    ></div>
                  </div>
                </div>

                <div className="language-item">
                  <span className="language-name">Deutsch</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-conversational"
                      style={{ width: '65%' }}
                    ></div>
                  </div>
                </div>

                <div className="language-item">
                  <span className="language-name">Nederlands</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-conversational"
                      style={{ width: '60%' }}
                    ></div>
                  </div>
                </div>

                <div className="language-item">
                  <span className="language-name">རྫོང་ཁ</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-basic"
                      style={{ width: '40%' }}
                    ></div>
                  </div>
                </div>

                <div className="language-item">
                  <span className="language-name">Wolof</span>
                  <div className="language-bar-container">
                    <div
                      className="language-bar language-bar-basic"
                      style={{ width: '40%' }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-cta">
            <h2>Get in Touch</h2>
            <Link to="/contact" className="btn-primary-modern">
              Contact Me
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
